<template>
  <div class="5c">
    <h3 class="uk-margin-medium-top">7 C. CONDICIONES DEL MERCADO O ENTORNO                  </h3>
    <p>Contesta las siguientes preguntas:</p>
    <form id="form" class="uk-text-left">


      <div class="uk-margin">
        <label >a) Situación económica de la región donde está la actividad económica del solicitante</label>
        <select class="uk-select" required v-model="data['a - Situación económica de la región donde está la actividad económica del solicitante']" >
          <option value="7">1    Estable</option>
          <option value="1">2    Inestable</option>
        </select>      
      </div>



      <div class="uk-margin">
        <label >b) ¿Cuál es el nivel de riesgo
de quebranto de la
actividad económica del
solicitante?</label>
        <select class="uk-select" required v-model="data['b - Riesgo de quebranto de la actividad económica del solicitante']" >
          <option value="0">Muy Alto riesgo</option>
          <option value="1">Alto riesgo</option>
          <option value="5">Medio riesgo</option>
          <option value="7">Bajo riesgo </option>
        </select>      
      </div>

      <div class="uk-margin">
        <label >c) Inseguridad en el sector o localidad donde vive el socio/aval</label>
        <select class="uk-select" required v-model="data['c - Inseguridad en el sector o localidad donde vive']" >
          <option value="0">Muy Alta</option>
          <option value="1">Alta</option>
          <option value="5">Media</option>
          <option value="7">Baja </option>
        </select>      
      </div>

      <div class="uk-margin uk-text-center">
         <button  class="uk-button uk-button-primary">siguiente</button>
      </div>


    </form>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      data : {},
    }
  },
  computed:{
    calif : function(){
      var value = 0.0
      for (var i in this.data){
        if(i == 'PUNTAJE TOTAL'){
          continue
        }
        if(!isNaN(parseFloat(this.data[i]))){
          value += parseFloat(this.data[i])
        }
      }
      value = value * 70.0 / 21.0
      value = value.toFixed(1)
      this.data['PUNTAJE TOTAL'] = value
      return value
    }
  },
  mounted: function(){
    document.getElementById('form').addEventListener('submit',function(e){
      e.preventDefault()
      var cal = this.calif + 1
      this.$score['7C CONDICIONES DEL MERCADO O ENTORNO'] = this.data
      sessionStorage.setItem('score',JSON.stringify(this.$score))
      this.$router.push('result')
    }.bind(this))
    window.scroll(0,0)
    this.$score = JSON.parse(sessionStorage.getItem('score'))
    if( this.$score['7C CONDICIONES DEL MERCADO O ENTORNO'] ) this.data = this.$score['7C CONDICIONES DEL MERCADO O ENTORNO'] 
  }
    
}
</script>
